import { SapService } from 'src/app/services/sap/sap.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { AngularFireFunctions } from 'angularfire2/functions';
import { SwalService } from 'src/app/services/alert/swal.service';
import { ApiService } from '../api/api.service';
import { AuthService } from '../auth/auth.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
	providedIn: 'root'
})
export class FunctionsService {

	constructor(
		public api: ApiService,
		private fireFunctions: AngularFireFunctions,
		public loadingCtrl: LoadingController,
		public auth: AuthService,
		private http: HttpClient,
		public SwalService: SwalService,
		public sapService: SapService
	) { }

	filterArray(query, orgArray, searchParams) {
		if (!query) {
			return Array.from(orgArray)
		} else {
			let results: any[] = []

			orgArray.forEach((d: any) => {
				for (let i = 0; i < searchParams.length; i++) {
					let param = searchParams[i]
					if (typeof param == "object") {
						if (d[param.p][param.sb] != undefined && String(d[param.p][param.sb]).toLowerCase().includes(query.toLowerCase())) {
							results.push(d)
							break
						}
					} else {
						if (d[param] != undefined && String(d[param]).toLowerCase().includes(query.toLowerCase())) {
							results.push(d)
							break
						}
					}
				}
			})

			return results
		}
	}

	sendEmail(id: string): Promise<void> {
		const sendOrder = this.fireFunctions.httpsCallable('sendOrder')
		return new Promise((resolve, reject) => {
			sendOrder({ id: id })
				.toPromise()
				.then(() => resolve())
				.catch((err) => {
                    if (err.code === 'permission-denied') {
                        console.error('No tienes permiso para acceder a este documento');
                        reject(null);
                    } else {
                        console.error(err);
                        reject(err);
                    }
                })
		});
	}

	async loader() {
		return await this.loadingCtrl.create({
			spinner: 'lines-small',
			animated: true,
			mode: 'ios',
			translucent: false,
			cssClass: 'custom-class custom-loading',
		});
	}

	async updateStatustime(order, status, statusOrder) {
		// Update status_time track time
		await this.api.getRef('orders').ref
			.where('number', '==', order.number)
			.get()
			.then(snapshots => {
				// this.total_orders = snapshots.size;
				snapshots.forEach(async element => {
					let order = element.data();
					order.date = order.added_date.toDate();
					order.$key = element.id;

					if (order.hasOwnProperty('status_time')) {
						let status_time = order.status_time
						status_time[status] = new Date()
						let obj = {}
						if (status == 'delivered') {
							obj = {
								'status_time': status_time,
								'status': statusOrder,
								'account_waiter': this.auth.token,
							}
						} else {
							obj = {
								'status_time': status_time,
								'status': statusOrder,
							}
						}
						await this.api.updateDocument('orders', order.$key, obj)
					}
				});
			})
	}

	async notificacionMSG(order, message) {
		let toDay = new Date()
		let fechaOrden = order.added_date;
		const startTime: any = new Date(fechaOrden);
		const endTime: any = new Date(toDay);
		const diff = endTime - startTime;
		const horastemporal: number = Math.floor((diff % 86400000) / 3600000);
		if (horastemporal > 0) {

		} else {
			// Notificacion al cliente segun la orden
			await this.api.getAllDocuments(`accounts/${order.account.$key}/push_keys`).then(async keys => {
				if (keys) {
					let push_keys = [];
					keys.forEach(element => {
						push_keys.push(element.push_key);
					});
					await this.api.sendPush(`Actualización de estado`, message, push_keys);
				}
			})
		}
		// mesaje de confirmacion de Cambio de estado
		this.SwalService.fire(
			'Estado actualizado!',
			'Tu estado ha sido actualizado correctamente',
			'success'
		)
	}

	changeStatus(order, status, gift = false) {
		return new Promise((resolve, reject) => {
			this.SwalService.fire({
				title: 'Estás seguro que deseas cambiar el estado?',
				text: "¡No podrás revertir esto!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Sí, estoy seguro'
			}).then(async (result) => {
				if (result.value) {
                    if (order.status == 'pending' && status != 'making') {
                        this.mensajeAlerta('error', `No se puede saltar el estado de la orden desde pendiente`);
                        return
                    } else if (order.status == 'making' && status != 'way') {
                        this.mensajeAlerta('error', `No se puede saltar el estado de la orden desde en preparacion`);
                        return
                    } else if (order.status == 'way' && status != 'delivered') {
                        this.mensajeAlerta('error', `No se puede saltar el estado de la orden desde en camino`);
                        return
                    }
					this.loader().then(loader => {
						loader.present().then(async () => {
                            
                        if (status != "delivered"){
                            await this.api.addDocument('orders/' + order.$key + '/history', {
                                date: new Date(),
                                action: "change-status",
                                user: this.auth.email,
                                oldData: {
                                    status: order.status,
                                    newStatus: status
                                }
                            })
                        }
							let statusOrder = ''
							if (status == 'pickup') {
								statusOrder = 'way'
							} else {
								statusOrder = status;
							}
							let message;
							if (status == 'making') {
								message = `Tu orden #${order.number} se está preparando 🔥`
							} else if (status == 'way') {
                                if ( !order.hasOwnProperty('isEticket') || order.isEticket == false ) {
                                    message = `Tu orden #${order.number} ya va de camino 🚚`
                                } else {
                                    message = `Tu E-Ticket llegara al correo registrado en la APP, revisa tu bandeja.`
                                }
							} else if (status == 'delivered') {
                                message = `Tu orden #${order.number} ha sido entregada 🏡`
                                 
							} else if (status == 'pickup' ) {
                                if ( !order.hasOwnProperty('isEticket') || order.isEticket == false ) {
                                    message = `Tu orden #${order.number} está lista para pasar por ella 🏪`
                                } else {
                                    message = `Tu E-Ticket llegara al correo registrado en la APP, revisa tu bandeja.`
                                }
							}
							if (status == 'pickup') {
								order.status = 'way'
							} else {
								order.status = status;
								let body = {
									token: this.auth.token,
									data: {
										numberOrder: order.number,
										type: "",
										message:""
									}

								}
								let headers = new HttpHeaders({
									'Access-Control-Allow-Origin': 'origin',
									'application': 'x-www-form-urlencoded',
									'Content-type': 'application/json',
									'Access-Control-Allow-Credentials': 'true',
									'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Origin, Cache-Control, Pragma, Authorization, Accept, Accept-Encoding',
									'Access-Control-Allow-Methods': 'PUT, POST, GET, OPTIONS, DELETE'
								}) 
								this.sapService.post("/service/orders/update/delivery/assignate", body, headers).subscribe({
								//this.sapService.post("https://service-dev.barlleno.app/service/orders/update/delivery/assignate", body, headers, true).subscribe({
									next: async (response) => {
										await this.api.addDocument('orders/' + order.$key + '/history', {
                                            date: new Date(),
                                            action: "assignate-delivery",
                                            user: this.auth.email,
                                            oldData: {
                                                status: order.status,
                                                newStatus: status,
                                                message: result.value,
                                                details: "assignate-message-urbano"
                                            }
                                        })
									},
									error: (error) =>{ 
										console.log(error)
									}
								})
							}
							if (gift) {
								message = message + `+ 2 🍺 Cervezas Gratis!!.`
							}
							if (status == "delivered" && !order.hasOwnProperty('points_add_applied')) {
								if (!order.hasOwnProperty('event_key')) {
                                    await this.api.addDocument('orders/' + order.$key + '/history', {
                                        date: new Date(),
                                        action: "change-status",
                                        user: this.auth.email,
                                        oldData: {
                                            status: order.status,
                                            newStatus: status,
                                            pointsApplied: false,
                                            applied_event_key: true
                                        }
                                    })
								} else {
                                    await this.api.addDocument('orders/' + order.$key + '/history', {
                                        date: new Date(),
                                        action: "change-status",
                                        user: this.auth.email,
                                        oldData: {
                                            status: order.status,
                                            newStatus: status,
                                            pointsApplied: true
                                        }
                                    })
									// si existe flag event_key solo procesar orden
									await this.api.updateDocument('orders', order.$key, {
										'points_add_applied': true,
										'applied_event_key': true
									})

									await this.updateStatustime(order, status, statusOrder)

									await this.notificacionMSG(order, message)
									// al finalizar el cambio de estado quita la orden de pantalla
									if (status == "delivered") {
										// await new Promise(r => setTimeout(r, 2000));
										// this.orders = this.orders.filter(element => element.number !== order.number)
										loader.dismiss();
										resolve(true)
									}
								}
							}
							else if (status == "making" || status == "way" || status == "pickup") {
								await this.updateStatustime(order, status, statusOrder)
								await this.notificacionMSG(order, message)
								loader.dismiss();
								resolve(true)
							}
							loader.dismiss();
							resolve(true)
						})
					})
				}
			})
		});
	}
	mensajeAlerta(icono: SweetAlertIcon, mensaje: string) {
		Swal.fire({
			position: 'top-end',
			icon: icono,
			title: mensaje,
			showConfirmButton: false,
			timer: 3500,
			toast: true
		});
	}
	capture(order) {
		return new Promise((resolve, reject) => {
			this.loader().then(loader => {
				loader.present().then(() => {
					this.SwalService.fire({
						title: 'Esta seguro que deseas Aceptar la transferencia?',
						text: "¡No podrás revertir esto!",
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Si, estoy seguro'
					}).then((result) => {

						if (result.value) {
							let getData = `orderNo=${order.number}&amount=${order.total}&type=1`;
							let transaction_id = order.transaction_id;
							let azulId = order.number;
							let url;
							if (!order.hasOwnProperty('TransactionIdentifier') && this.auth.countryCode == 'SV') {
								// FAC 3DSv1
								url = `https://payments.barlleno.app/transactionModification.php?${getData}`;

							} else if (order.hasOwnProperty('TransactionIdentifier') && (this.auth.countryCode == 'SV' || this.auth.countryCode == 'GT')) {
								// nuevo FAC 3DSv2 
								const httpOptions = {
									headers: new HttpHeaders({
										'Access-Control-Allow-Origin': 'origin',
										'application': 'x-www-form-urlencoded',
										'Content-type': 'application/json',
										'Access-Control-Allow-Credentials': 'true',
										'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, Origin, Cache-Control, Pragma, Authorization, Accept, Accept-Encoding',
										'Access-Control-Allow-Methods': 'PUT, POST, GET, OPTIONS, DELETE'
									})
								};

								let body = {
									"TransactionIdentifier": order.TransactionIdentifier,
									"TotalAmount": Number(order.total),
									"ExternalIdentifier": `${order.number}`
								}
								//  console.log("transaccion body = ", body, typeof body)

								url = `https://payments.paggi.app/powerTranz/${this.auth.countryCode}/Capture.php`;
								// url = `https://payments.paggi.app/powerTranz/SV/Capture.php`;

								this.http.post(url, JSON.stringify(body), httpOptions)
									.subscribe((response) => {
										//  console.log("POST -> Capture.php response = ", JSON.stringify(response))
										if (response['IsoResponseCode'] == '00') {
											this.api.updateDocument('orders', order.$key, {
												'transaction_status': 'captured',
												'status': 'making'
											}).then(data => {
												order.transaction_status = 'captured';
												this.SwalService.fire(
													'Transacción Capturada',
													'Captura de fondos realizar con exito',
													'success'
												)
											})
										} else {
											this.SwalService.fire(
												'Error!',
												`No se pudo completar la captura de transaccion, comunicate con el equipo de barlleno ${response['ResponseMessage']}`,
												'error'
											)
										}
										loader.dismiss();
										resolve(true)
									}, err => {
										loader.dismiss();
										resolve(true)
									});
							} else if (this.auth.countryCode == 'GT') {
								url = `https://payments.barlleno.app/gt/transactionModification.php?${getData}`;
							} else if (this.auth.countryCode == 'HN') {
								this.api.updateDocument('orders', order.$key, {
									'transaction_status': 'captured',
									'status': 'making'
								}).then(data => {
									order.transaction_status = 'captured';
									this.SwalService.fire(
										'Transacción Capturada',
										'Captura de fondos realizar con exito',
										'success'
									)
								})
								loader.dismiss();
								resolve(true)
							} else if (this.auth.countryCode == 'CO') {
								const httpOptions = {
									headers: new HttpHeaders({
										'Authorization': 'Bearer prv_prod_PWw13Ai1yGYJuTF6BQJ99nG8w9MkTHAw'
									})
								};
								url = ((`https://production.wompi.co/v1/transactions/${transaction_id}`));
							}
							// agregando captura metodo de pago DO
							else if (this.auth.countryCode == 'DO') {
								url = ((`https://paymentsdr.barlleno.app/src/Azul/verifySale.php?${azulId}`));
								// console.log("--->Enviamos al endpoint");
								// console.log(azulId);
							}

							if (!order.hasOwnProperty('TransactionIdentifier') && (this.auth.countryCode == 'SV' || this.auth.countryCode == 'GT')) {
								this.http.get(url)
									.subscribe((response) => {
										if (response['TransactionModificationResult']['ResponseCode'] == 1) {
											this.api.updateDocument('orders', order.$key, {
												'transaction_status': 'captured',
												'status': 'making'
											}).then(data => {
												order.transaction_status = 'captured';
												this.SwalService.fire(
													'Transacción Capturada',
													'Captura de fondos realizar con exito',
													'success'
												)
											})
										} else {
											this.SwalService.fire(
												'Error!',
												'No se pudo completar la captura de transaccion, comunicate con el equipo de barlleno',
												'error'
											)
										}
										loader.dismiss();
										resolve(true)
									}, err => {
										loader.dismiss();
										resolve(true)
									});
							}
							else if (this.auth.countryCode == 'CO') {
								const httpOptions = {
									headers: new HttpHeaders({
										'Authorization': 'Bearer prv_prod_PWw13Ai1yGYJuTF6BQJ99nG8w9MkTHAw'
									})
								};
								this.http.get(url, httpOptions)
									.subscribe((response) => {
										if (response['data']['status'] == 'APPROVED') {
											this.api.updateDocument('orders', order.$key, {
												'transaction_status': 'captured',
												'status': 'making'
											}).then(data => {
												order.transaction_status = 'captured';
												this.SwalService.fire(
													'Transacción Capturada',
													'Captura de fondos realizar con exito',
													'success'
												)
											})
										} else {
											this.SwalService.fire(
												'Error!',
												'No se pudo completar la captura de transaccion, comunicate con el equipo de barlleno',
												'error'
											)
										}
										loader.dismiss();
										resolve(true)
									}, err => {
										loader.dismiss();
										resolve(true)
									});
							} else if (this.auth.countryCode == 'DO') {
								this.http.get(url)
									.subscribe((response) => {
										// console.log("--->Recibimos");
										// console.log(response);

										if (response['Found'] == false) {
											this.api.updateDocument('orders', order.$key, {
												'transaction_status': 'captured',
												'status': 'making'
											}).then(data => {
												order.transaction_status = 'captured';
												this.SwalService.fire(
													'Transacción Capturada',
													'Captura de fondos realizar con exito',
													'success'
												)
											})
										} else {
											this.SwalService.fire(
												'Error!',
												'No se pudo completar la captura de transaccion, comunicate con el equipo de barlleno',
												'error'
											)
										}
										loader.dismiss();
										resolve(true)
									}, err => {
										loader.dismiss();
										resolve(true)
									});
							}
						} else {
							loader.dismiss();
							resolve(true)
						}
					});
				})
			})
		});
	}

	captureCash(order) {
		return new Promise((resolve, reject) => {
			this.loader().then(loader => {
				loader.present().then(() => {
					this.SwalService.fire({
						title: 'Esta seguro que deseas Aceptar el Pago?',
						text: "¡No podrás revertir esto!",
						icon: 'warning',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Si, estoy seguro'
					}).then((result) => {

						if (result.value) {
							if (!order.hasOwnProperty('transaction_status') && (this.auth.countryCode == 'SV' || this.auth.countryCode == 'HN')) {
								this.api.updateDocument('orders', order.$key, {
									'transaction_status': 'taken',
									'status': 'making',
									'account_waiter': this.auth.token
								}).then(data => {
									order.transaction_status = 'taken';
									this.SwalService.fire(
										'Pago Recibido',
										'Pago Aceptado, orden actualizada con exito',
										'success'
									)
								})
							}
							loader.dismiss();
							resolve(true)
						} else {
							loader.dismiss();
							resolve(false)
						}
					});
				})
			})
		});
	}

}
